import business from './business.json';
import enterprise from './enterprise.json';
import infrastructure from './infrastructure.json';
import security from './security.json';
import support from './support.json';

export default [
    business,
    enterprise,
    infrastructure,
    security,
    support
]